export default __webpack_public_path__ + "static/media/Montserrat-Light.4f61273a.ttf";